import classNames from 'classnames';
import { ComponentProps } from 'react';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { DragCursorIcon, MailIcon } from './icons';

import './style.scss';

export function DragDropCard({ className, ...props }: Omit<ComponentProps<'div'>, 'children'>) {
  return (
    <Card
      className={classNames('quick-start-card border border-opacity-40 bg-transparent overflow-hidden', className)}
      {...props}
    >
      <Card.Header className="p-3">
        <Card.Title as="h5">
          <FormattedMessage
            id="smartQuote.quickStart.card2.title"
            defaultMessage="Drag & drop request anywhere in this page"
          />
        </Card.Title>
      </Card.Header>
      <Card.Body className="flex-y align-items-center p-4 pt-0 position-relative">
        <div
          className="flex-x justify-content-between align-items-end bg-secondary bg-opacity-10 p-2 w-100 "
          style={{ height: '45%' }}
        >
          <i className="icon icon-outlined icon-sm text-secondary lh-1">add</i>
          <i className="icon icon-outlined icon-sm text-secondary lh-1">arrow_forward</i>
        </div>
        <div className="mail-file-name p-12px pt-1 position-absolute" style={{ top: '24px' }}>
          <MailIcon />
          <span className="fs-12">Pricing request.msg</span>
          <DragCursorIcon />
        </div>
      </Card.Body>
    </Card>
  );
}
